//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    name: 'owner-activity',
    props: {
        memberId: {
            type: Number,
            required: true
        }
    },
    data() {
        var vm = this;
        return {
            columns: [
                {
                    type: 'index', width: 60, align: 'center'
                },
                {
                    title: '活动名称',
                    align: 'center',
                    key: 'activityName',
                    minWidth: 150,
                    render: (h, params) => {
                        const row = params.row;
                        const actions = [];
                        actions.push(h('a', {
                            on: {
                                click() {
                                    vm.showActivityDetail(row);
                                }
                            }
                        }, row.activityName));
                        return h('div', actions);
                    }
                },
                {
                    title: '活动类型',
                    align: 'center',
                    key: '',
                    minWidth: 100,
                    render: (h, params) => {
                        const row = params.row;
                        return h('span', row.activity.activityType === 0 ? '线上' : '线下');
                    }
                },
                {
                    title: '活动地点',
                    align: 'center',
                    key: '', minWidth: 100,
                    render: (h, params) => {
                        const row = params.row;
                        return h('span', row.activity.address);
                    }
                },
                {
                    title: '活动状态',
                    align: 'center',
                    key: '', minWidth: 120,
                    render: (h, params) => {
                        const row = params.row;
                        return h('span', row.activity.activityStatusStr);
                    }
                },
                {
                    title: '活动人数',
                    align: 'center',
                    key: '', minWidth: 100,
                    render: (h, params) => {
                        const row = params.row;
                        return h('span', row.activity.isLimit ? row.activity.totalNum : '不限');
                    }
                },
                {
                    title: '活动开始时间',
                    align: 'center',
                    key: '', minWidth: 150,
                    render: (h, params) => {
                        // if (params.row.purchaseDate) {
                        const row = params.row;
                        return h('span', row.activity.startDateTimeStr);
                        // }
                    }
                },
                {
                    title: '活动结束时间',
                    align: 'center',
                    key: '', minWidth: 150,
                    render: (h, params) => {
                        // if (params.row.purchaseDate) {
                        const row = params.row;
                        return h('span', row.activity.endDateTimeStr);
                        // }
                    }
                },
                {
                    title: '报名开始时间',
                    align: 'center',
                    key: '', minWidth: 150,
                    render: (h, params) => {
                        const row = params.row;
                        if (row.activity.signUpStartTimeStr) {
                            return h('span', row.activity.signUpStartTimeStr);
                        } else {
                            return h('span', '');
                        }
                    }
                },
                {
                    title: '报名截止时间',
                    align: 'center',
                    key: '', minWidth: 150,
                    render: (h, params) => {
                        const row = params.row;
                        if (row.activity.signUpEndTimeStr) {
                            return h('span', row.activity.signUpEndTimeStr);
                        } else {
                            return h('span', '');
                        }
                    }
                },
                {
                    title: '姓名',
                    align: 'center', minWidth: 100,
                    key: 'name'
                },
                {
                    title: '手机号',
                    align: 'center', minWidth: 130,
                    key: 'phoneNumber'
                },
                {
                    title: '报名时间',
                    align: 'center', minWidth: 150,
                    key: 'signUpTimeStr'
                }
            ],
            searchInput: {},
            loading: false,
            currentPage: 1,
            totalCount: 0,
            pageSize: 10,
            list: [],
            pageSizeOpts: [10, 20, 30, 40, 50]
        };
    },
    methods: {
        pageChange(page) {
            this.currentPage = page;
            this.getPage();
        },
        pageSizeChange(pagesize) {
            this.pageSize = pagesize;
            this.getPage();
        },
        getPage() {
            if (!parseInt(this.memberId) > 0) {
                return;
            }
            this.searchInput.memberId = parseInt(this.memberId);
            this.searchInput.maxResultCount = this.pageSize;
            this.searchInput.skipCount = (this.currentPage - 1) * this.pageSize;
            this.loading = true;
            abp.ajax.post('/api/services/app/Activity/SearchSignUpRecords', this.searchInput).then(res => {
                this.list = [];
                this.list.push(...res.data.result.items);
                this.totalCount = res.data.result.totalCount;
            }).finally(() => {
                this.loading = false;
            });
        },
        showActivityDetail(row) {
            console.log(row);
            this.$router.push({
                name: 'activityDetail',
                params: {
                    id: row.activityId
                }
            });
        }
    },
    created() {
        this.getPage();
    },
    watch: {
        memberId(val, oldVal) {
            if (parseInt(val) > 0) {
                this.currentPage = 1;
                this.getPage();
            }
        }
    }
};
